var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "material-symbols:call"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.911377,
    y: 0.792725,
    width: 26.7114,
    height: 26.7114,
    rx: 13.3557,
    fill: "black",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.5276 21.2266C18.8526 21.2266 17.2199 20.8532 15.6295 20.1063C14.0391 19.3594 12.6303 18.3726 11.403 17.1458C10.1757 15.919 9.18883 14.5101 8.44246 12.9193C7.6961 11.3284 7.32266 9.69567 7.32214 8.02116C7.32214 7.78744 7.40005 7.59267 7.55587 7.43685C7.71168 7.28103 7.90646 7.20312 8.14018 7.20312H11.2955C11.4773 7.20312 11.6396 7.26156 11.7824 7.37842C11.9252 7.49528 12.0096 7.64461 12.0356 7.82639L12.542 10.5532C12.568 10.735 12.5646 10.9007 12.5319 11.0502C12.4991 11.1998 12.4246 11.3328 12.3083 11.4491L10.4385 13.3579C10.9838 14.2928 11.6655 15.1692 12.4836 15.9873C13.3016 16.8053 14.204 17.513 15.1909 18.1103L17.0217 16.2794C17.1386 16.1626 17.2913 16.0751 17.4798 16.0169C17.6684 15.9587 17.8533 15.9424 18.0345 15.9678L20.7224 16.5132C20.9042 16.5521 21.0535 16.6399 21.1703 16.7765C21.2872 16.9131 21.3456 17.072 21.3456 17.2533V20.4086C21.3456 20.6423 21.2677 20.8371 21.1119 20.9929C20.9561 21.1487 20.7613 21.2266 20.5276 21.2266Z",
    fill: "#0D4672"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.eddbb49d798014358703ce5cf9bbddba.svg";
export { ForwardRef as ReactComponent };